// --no-test-for-file

import {useEffect} from "react"
import {Client} from "@stomp/stompjs"
import {useGetAndFetchToken} from "./useGetAndFetchToken"
import {useDispatch} from "../store"
import {addNewRequest} from "../features/device-add-requests/deviceAddRequestSlice"
import {sendNotification} from "../utils/sendNotification"
import {DeviceAddResponse} from "../types/Device"

export const useWebsocket = () => {
  const {token, user, loading} = useGetAndFetchToken()
  const dispatch = useDispatch()
  const client = new Client({
    brokerURL: process.env.REACT_APP_WEBSOCKET_URL,
    connectHeaders: {
      Authorization: `Bearer ${token}`
    },
    reconnectDelay: 5000,
    heartbeatIncoming: 4000,
    heartbeatOutgoing: 4000
  })

  useEffect(() => {
    if (client) {
      client.onConnect = function () {
        // Вывод сообщения об подключении
        console.log("Websocket - CONNECTED!")

        client.subscribe(`/devices/registration`, function (msg) {
          if (msg.body) {
            const data: DeviceAddResponse["data"][0] = JSON.parse(msg.body)
            // Добавить запрос
            dispatch(addNewRequest(data))
            sendNotification(data)
          }
        })
      }
      // Если подключение нет, то подключиться
      if (!client.active) client.activate()
      // Отключение
      return () => {
        client.deactivate().then()
      }
    }
  }, [client, user])

  return {client, loading, user, token}
}
